import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { or } from 'ember-truth-helpers';

<template>
  <span ...attributes>
    <FaIcon @icon={{@icon}} @size={{or @size "xl"}} class={{@class}} />
  </span>
</template>
